import _asyncToGenerator from "/home/runner/_work/dataschoolv2/dataschoolv2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/runner/_work/dataschoolv2/dataschoolv2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/home/runner/_work/dataschoolv2/dataschoolv2/node_modules/@babel/runtime/regenerator/index.js";
import "core-js/modules/es.promise.finally.js";
//react-geolocate

import { useState, useEffect } from "react";
var useGeoLocation = function useGeoLocation() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _useState = useState(options.country),
    _useState2 = _slicedToArray(_useState, 2),
    country = _useState2[0],
    setCountry = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  var api = options.api || "https://api.country.is";
  useEffect(function () {
    var isCancelled = false;
    if (country || country === false) return;
    function fetchAPI() {
      return _fetchAPI.apply(this, arguments);
    }
    function _fetchAPI() {
      _fetchAPI = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              _context.next = 3;
              return fetch(api).then(function (res) {
                if (!res.ok) {
                  throw Error(res.statusText);
                  return null;
                }
                return res.json();
              }).then(function (res) {
                if (res && res.country && !isCancelled) setCountry(res.country);
              }).catch(function (err) {
                return setError(err);
              }).finally(function () {
                return setIsLoading(false);
              });
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _fetchAPI.apply(this, arguments);
    }
    fetchAPI();
    return function () {
      isCancelled = true;
    };
  }, []);
  return {
    country: country,
    error: error,
    isLoading: isLoading
  };
};
export default useGeoLocation;